import { SPA_FLAG, SEARCH_KEYS } from '../constants';
import { SearchForm, TargetType } from '../types';

type DateType = string;

const prepareUrlParams = (formValues: SearchForm<DateType>) => {
  const { departure, departureOption, destination, destinationOption, date, adults, childrenAges } =
    formValues;

  return {
    query: {
      [SEARCH_KEYS.START_GEO_ID]:
        departureOption.targetType === TargetType.GeoPoint ? departureOption.value : undefined,
      [SEARCH_KEYS.END_GEO_ID]:
        destinationOption.targetType === TargetType.GeoPoint ? destinationOption.value : undefined,
      [SEARCH_KEYS.DEPARTURE_STATION_ID]:
        departureOption.targetType === TargetType.Station ? departureOption.value : undefined,
      [SEARCH_KEYS.ARRIVAL_STATION_ID]:
        destinationOption.targetType === TargetType.Station ? destinationOption.value : undefined,
      [SEARCH_KEYS.RUN_NAME]: `${departure} — ${destination}`,
      [SEARCH_KEYS.ADULTS]: adults,
      [SEARCH_KEYS.CHILDREN]: childrenAges?.length || 0,
      [SEARCH_KEYS.CHILDREN_AGES]: childrenAges,
      [SEARCH_KEYS.DATE]: date,
      [SPA_FLAG]: true,
    },
    seoPath: `${departureOption.translit}_${destinationOption.translit}`.toLowerCase(),
  };
};

export type UrlParams = ReturnType<typeof prepareUrlParams>;

export default prepareUrlParams;
